import {
    BetWayWinIndividualWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Timeline, TimelineLite} from "gsap";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MonkeysGoldReelSymbol} from "../../symbols/MonkeysGoldReelSymbol";
import {IMonkeysGoldBetWayWinData, MonkeysGoldWaysWonGFXText} from "./MonkeysGoldWaysWonGFXText";
import {
    IIndividualWinPresentationConfig
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {MonkeysGoldParsedInitData} from "../../server/data/MonkeysGoldParsedInitData";

export class MGIndividualWinController extends BetWayWinIndividualWPController {

    private _waysWon: MonkeysGoldWaysWonGFXText;
    private _winWaysWon: number = 0;
    private _winWaysAmount: number = 0;
    private _startDelayTL: TimelineLite;
    private _lineAnimationTL: TimelineLite;
    private _mode: string;
    private _nextMode: string;

    constructor(config: IIndividualWinPresentationConfig, name?: string, tweakEnabled?: boolean) {
        super(config, name, tweakEnabled);
        this._waysWon = new MonkeysGoldWaysWonGFXText();
        EventHandler.addEventListener(this, "STOP_INDIVIDUAL_WIN_FROM_AS", () => {
            this.stopWinPresentation(false, true);
        })
    }

    public stopWinPresentation(isAborted: boolean, isCallFromAS: boolean = false) {
        super.stopWinPresentation(isAborted);
        if (this._startDelayTL && this._startDelayTL.isActive()) {
            this._startDelayTL.pause();
            this._startDelayTL.kill();
        }
        if (this._lineAnimationTL && this._lineAnimationTL.isActive()) {
            this._lineAnimationTL.pause();
            this._lineAnimationTL.kill();
        }
        this._waysWon.abort(isAborted, isCallFromAS ? false : this._gameData!.isBigWin);
    }

    public resetFeature(): void {
        this._winWaysWon = 0;
    }

    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected parseFeatureGameData(data: MonkeysGoldParsedGameData) {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
    }

    protected hasWin(): boolean {
        // Don't play after FS
        if ((this._mode == GameMode.FREESPIN || this._mode == GameMode.FREESPIN_AVALANCHE) && this._nextMode == GameMode.NORMAL) {
            return false;
        } else {
            return this._betWinsData != null && this._betWinsData.length > 0;
        }
    }

    protected startWinPresentation() {
        this._startDelayTL = new TimelineLite();
        this._startDelayTL.add(() => super.startWinPresentation(), "+=1.5");
    }

    protected getLineAnimation(betWayWinData: IMonkeysGoldBetWayWinData): Timeline {
        this._lineAnimationTL = new TimelineLite();
        const reelsNum: number = GameConfig.instance.REELS_NUM;
        let currentDuration: number = 0;
        this._winWaysWon = betWayWinData.symbolCount;
        this._winWaysAmount = betWayWinData.amount;

        this._lineAnimationTL.add(() => {
            this._waysWon.position.y = 140 + (this.getXPaysYPosition(betWayWinData) * 99);
            this._waysWon.position.x = 40 + (this.getXPaysXPosition(betWayWinData) * 99);
        }, "+=0.2");
        this._lineAnimationTL.add(() => {
            this._waysWon.showWinWaysWon(this._winWaysWon, this._winWaysAmount, true);
        });
        this._lineAnimationTL.add(new TimelineLite({delay: 1.5}));
        if (this._betWinsData && this._betWinsData.length > 1) {
            this._lineAnimationTL.add(() => this._waysWon.fadeOut());
        }

        for (let i: number = 0; i < reelsNum; i++) {
            for (let j: number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                const symbol = Reels.getSymbol(i, j);
                if (symbol) {
                    if (betWayWinData.reelWinPositions[i][j]) {
                        this.addSymbolWinAnimationToTimeline(betWayWinData, this._lineAnimationTL, 0.2, symbol, i, j);
                        if (this._winSymbols.indexOf(symbol) === -1) {
                            this._winSymbols.push(symbol);
                        }
                    } else {
                        symbol.changeState({
                            state: GameConfig.instance.SYMBOL_STATES.noWin!,
                            fadeInDuration: 0.3
                        });
                        if (symbol.symName.indexOf("colossalx2") > -1 || symbol.symName.indexOf("colossalx3") > -1) {
                            (<MonkeysGoldReelSymbol>symbol).getMultiplierTextNoWinTint();
                        }
                    }
                }
            }
        }

        return this._lineAnimationTL;
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData: IBetWayWinData, timeline: Timeline, startTime: number, symbol: StateReelSymbol, reelId: number, symbolId: number): void {
        timeline.add([
            () => this.sortSymbolDepthToTop(symbol),
            symbol.changeState({
                state: GameConfig.instance.SYMBOL_STATES.win,
                setStack: true,
                fadeInDuration: 0.4,
            }),
            () => {
                if (symbol.symName.indexOf("colossalx2") > -1 || symbol.symName.indexOf("colossalx3") > -1) {
                    (<MonkeysGoldReelSymbol>symbol).getMultiplierTextWinTint();
                }
            }
        ], startTime);
        timeline.add(() => {
            if ((symbol && symbol.symName == "W" || symbol.symName == "W_hidden") && this._betWinsData!.length > 1) {
                symbol.changeState({
                    state: GameConfig.instance.SYMBOL_STATES.noWin!,
                    setStack: true,
                    fadeInDuration: 0.3
                });
            }
        });
    }

    private onInitDataParsed(data: MonkeysGoldParsedInitData): void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
    }

    private getXPaysYPosition(betWayWinData: IMonkeysGoldBetWayWinData): number {
        let topRow: number = 6;
        let bottomRow: number = -1;
        for (let i: number = 0; i < betWayWinData.reelWinPositions.length; i++) {
            for (let j: number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                if (betWayWinData.reelWinPositions[i][j] == true) {
                    if (j > bottomRow) {
                        bottomRow = j;
                    }
                    if (j < topRow) {
                        topRow = j;
                    }
                }
            }
        }
        return topRow + (bottomRow - topRow) / 2;
    }

    private getXPaysXPosition(betWayWinData: IMonkeysGoldBetWayWinData): number {
        let rightReel: number = 6;
        let leftReel: number = -1;
        for (let i: number = 0; i < betWayWinData.reelWinPositions.length; i++) {
            for (let j: number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                if (betWayWinData.reelWinPositions[i][j] == true) {
                    if (i > leftReel) {
                        leftReel = i;
                    }
                    if (j < rightReel) {
                        rightReel = i;
                    }
                }
            }
        }
        return leftReel + (rightReel - leftReel) / 2;
    }
}